import React from "react";
import { motion } from "framer-motion";
import "./mathrudeepti.css";

function Mathrudeepti() {
  return (
    <>
      <h2 className="mathrudeepti-heading">Mathrudeepti</h2>
    
    <motion.div
      initial={{ x: "-100vw", opacity: 0 }} // Start position (off-screen left)
      animate={{ x: 0, opacity: 1 }} // End position (fully visible)
      transition={{ type: "tween", duration: 3 }} // Smooth transition
    >
      <div className="container">
        <p>
          Mathrudeepti is a fellowship of mothers at Deepti who come together,
          share their experience, hope, improvement of their children in order
          to encourage and strengthen each other in their challenges and
          struggles.
        </p>
        <p>
          Mathrudeepti gives emotional support and guidance for parents,
          especially to mothers who are burdened with challenges of bringing up
          a child or children with special needs.
        </p>
      </div>
    </motion.div>
    </>
  );
}

export default Mathrudeepti;
